import React from "react";
import { Link } from "react-router-dom";
import { ContentWrapper } from "../../components/Content/Wrapper";
import { validateRoute } from "../helpers/auth";

export function AppRentalsActions() {

    const content = () => {
        return (
            <div className="tiles__wrapper">
                {validateRoute('/rentals/actions/scan') === true &&
                    <div className="tiles__column">
                        <Link to={"/rentals/actions/scan"} className={"tile tile__scannen active"}>
                            <span className="icon"></span>
                            <span className="tile__title">
                                Scannen
                            </span>
                        </Link>
                    </div>
                }
                {validateRoute('/rentals/actions/request') === true &&
                    <div className="tiles__column">
                        <Link to={"/rentals/actions/request"} className={"tile tile__verhuur"}>
                            <span className="icon"></span>
                            <span className="tile__title">
                                Nieuwe aanvraag verhuur
                            </span>
                        </Link>
                    </div>
                }
            </div>
        )
    }

    return (
        <ContentWrapper type="tiles-secondary" content={content()} />
    );
}